import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import { useState } from 'react';
import apis from '../config';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

export default function useUpdateSacrament() {
  const [level, setLevel] = useState('');
  const [studentArray, setStudentArray] = useState([]);
  const [sacramentDetails, setSacramentDetails] = useState({
    type: 'fr',
    date: dayjs().format('YYYY-MM-DD'),
  });

  const { data } = useQuery(
    ['sac', level],
    async () => {
      if (level !== '') {
        const formData = new FormData();
        formData.append('auth', localStorage.getItem('token'));
        formData.append('function', 'getStudentFromLevel');
        formData.append('level', level);

        const output = await axios.post(apis.API, formData);
        if (output.data.response.students.length > 0) {
          setStudentArray(output.data.response.students);
          return output.data.response.students;
        } else {
          return false;
        }
      } else {
        setStudentArray([]);
      }
    },
    {
      keepPreviousData: true,
      cacheTime: 0,
    }
  );

  const handleLevelChange = e => {
    setLevel(e?.target?.value);
  };

  const removeStudent = id => {
    const updatedStudents = studentArray.filter(
      student => student.student_id !== id
    );
    setStudentArray(updatedStudents);
  };

  const formHandler = useMutation(async formData => {
    const output = await axios.post(apis.STUDENTS_API, formData);

    if (output.data.response.status === 'OK') {
      toast.success('Sacrament dates added and saved', {
        // position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  });

  const saveForm = async () => {
    const formData = new FormData();
    formData.append('auth', localStorage.getItem('token'));
    formData.append('mode', 'updateSacrament_v2');
    formData.append('type', sacramentDetails.type);
    formData.append('date', sacramentDetails.date);
    formData.append('students', JSON.stringify(studentArray));
    formHandler.mutate(formData);
  };

  return {
    data,
    setLevel,
    handleLevelChange,
    studentArray,
    removeStudent,
    saveForm,
    sacramentDetails,
    setSacramentDetails,
  };
}
